/**
 * Typed environment variables
 */

interface EnvConfig {
  /** API base URL for the current environment */
  apiBaseUrl: string;
  /** Default subdomain for local development */
  defaultSubdomain: string;
  /** Whether we're in production mode */
  isProd: boolean;
  /** Whether we're in development mode */
  isDev: boolean;
  /** Stripe v2 key for dual tokenization with MercadoPago */
  stripeFallbackKey: string;
  /** MercadoPago publishable key for marketplace restaurants */
  mpPublishableKey: string;
}

/**
 * Get typed environment configuration
 */
export function getEnvConfig(): EnvConfig {
  return {
    apiBaseUrl: import.meta.env.VITE_API_BASE_URL || 'https://api-test.meitre.com',
    defaultSubdomain: import.meta.env.VITE_DEFAULT_SUBDOMAIN || '',
    isProd: import.meta.env.PROD,
    isDev: import.meta.env.DEV,
    stripeFallbackKey: import.meta.env.VITE_STRIPE_FALLBACK_KEY || '',
    mpPublishableKey: import.meta.env.VITE_MP_PUBLISHABLE_KEY || '',
  };
}

/**
 * Convenience exports
 */
export const env = getEnvConfig();
